<!-- Main -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">
      <header><h2><b>Success</b></h2></header>


      <div class="row">
        <div class="col-12-medium">

          @if (isLoading) {
            <div >
              <div class="spinner-container">
                <div class="spinner"></div>
              </div>
              <h5>Retrieving data...</h5>
            </div>
          }
        </div>
      </div>



      <div class="row">
        <div class=" col-12">

          @if (!isLoading) {
            <div>
              <div class="details-container">
                <div class="payment-status-container">
                  <h4>Payment</h4>
                  <i class="fa fa-check payment-status-icon" aria-hidden="true"></i>
                </div>
                @if (displayType === 'RRZC') {
                  <div>
                    <div >
                      <div >
                        <h5 class="class-name">{{ displayData.name }}</h5>
                        <p>{{ displayData.description }}</p>
                        <p>Date: {{ displayData.date }}</p>
                        <p>Time: {{ displayData.time }}</p>
                        <p><b>URL: </b>
                        <a href="{{ displayData.url }}" target="_blank" rel="noopener noreferrer" class="purchase-link">
                          {{ displayData.url }}
                        </a>
                      </p>
                      <p><b>Password: </b>{{ displayData.password }}</p>
                      <p><b>Class Files: </b>
                      <a href="{{displayData.classFilesURL}}" target="_blank" rel="noopener noreferrer" class="purchase-link">
                        {{ displayData.classFiles }}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            }
            @if (displayType === 'RRZA') {
              <div>
                <div >
                  <div >
                    <h5 class="class-name">{{ displayData.name }}</h5>
                    <p>{{ displayData.description }}</p>
                    <p>Date: {{ displayData.date }}</p>
                    <p>Time: {{ displayData.time }}</p>
                    <p><b>URL: </b>{{ displayData.url }} </p>
                    <p><b>Password: </b>{{ displayData.password }}</p>
                    <p><b>Class Files: </b>
                    <a href="{{displayData.classFilesURL}}" target="_blank" rel="noopener noreferrer" class="purchase-link">
                      {{ displayData.classFiles }}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          }
          @if (displayType === 'RRBC') {
            <div>
              <div >
                <div >
                  <h5 class="class-name">{{ displayData.name }}</h5>
                  <p>{{ displayData.description }}</p>
                  <p>Date: {{ displayData.date }}</p>
                  <p>Time: {{ displayData.time }}</p>
                  <p>Building: {{ displayData.locationName }}</p>
                  <p>Street: {{ displayData.street }}</p>
                  <p>City: {{ displayData.city }}</p>
                  <p>State: {{ displayData.state }}</p>
                  <p>Zip: {{ displayData.zip}}</p>
                  <p><b>Class Files: </b>
                  <a href="{{displayData.classFilesURL}}" target="_blank" rel="noopener noreferrer" class="purchase-link">
                    {{ displayData.classFiles }}
                  </a>
                </p>
              </div>
            </div>
          </div>
        }
        @if (displayType === 'RRVT') {
          <div>
            <div >
              <div >
                <h5>{{ displayData.name }}</h5>
                <p><b>Class Files: </b>
                <a href="{{displayData.classFilesURL}}" target="_blank" rel="noopener noreferrer" class="purchase-link">
                  {{ displayData.classFiles }}
                </a>
              </p>
              <br>
                <p>You can now play your video in your member area.</p>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
</div>

<ng-container *ngIf="auth.loggedIn$ | async">
  <div>
    <div class="col-12">
      <ul class="actions">
        <li><input type="submit" value="Member" class="primary successBtn" routerLink="/member"></li>
      </ul>
    </div>
  </div>
</ng-container>

<div class="col-12">
  <ul class="actions">
    <li><input type="submit" value="Home" class="primary successBtn" routerLink="/home"></li>
  </ul>
</div>

</div>
</div>
</section>

